const white = {
   50: '#888888',
   100: '#898989',
   200: '#999999',
   300: '#A9A9A9',
   400: '#AAAAAA',
   500: '#BBBBBB',
   600: '#BCBCBC',
   700: '#CCCCCC',
   800: '#DCDCDC',
   900: '#DDDDDD',
   A100: '#EDEDED',
   A200: '#EEEEEE',
   A400: '#FEFEFE',
   A700: '#FFFFFF'
}

export default white
